import React from 'react';
import cx from 'classnames';
import {Link} from 'gatsby';
import {Modal, Slide} from '@mui/material';
import {MenuItem} from 'src/components/menu-item';
import {Backdrop} from 'src/components/backdrop';
import {useStoreContext, useToggleSubmenu} from 'src/context/storeContext';
import {getInternalLinkPath} from 'src/utils/getInternalLinkPath';
import * as styles from './submenu.module.css';

export const Submenu = ({clickHandler, menu}) => {
	const {noticeBarVisible, submenuIsOpen} = useStoreContext();
	const toggleSubmenu = useToggleSubmenu();
	return (
		<>
			<Modal
				open={submenuIsOpen}
				onClose={toggleSubmenu}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{active: submenuIsOpen, toggle: toggleSubmenu}}
				aria-modal="true"
				aria-labelledby="menuTitle">
				<Slide
					direction="right"
					in={submenuIsOpen}
					timeout={{
						enter: 400,
						exit: 250,
					}}>
					<div
						className={cx(
							styles.submenu,
							noticeBarVisible ? styles.noticeBarVisible : '',
						)}
						role="presentation">
						<div className={styles.inner}>
							<nav>
								<ul role="menu">
									{menu &&
										menu.items.map(item => {
											return (
												<MenuItem
													className={cx(
														styles.menuItem,
														submenuIsOpen
															? styles.reveal
															: '',
													)}
													item={item}
													key={item._key}
													clickHandler={event =>
														clickHandler(
															event,
															item,
														)
													}>
													<span className="headline c-gold italic-underline-on-hover">
														{item.title}
													</span>
												</MenuItem>
											);
										})}
								</ul>
							</nav>
							{menu && menu.additionalLinkTarget && (
								<div
									className={cx(
										styles.additionalLinkContainer,
										submenuIsOpen ? styles.reveal : '',
									)}>
									<Link
										className={cx(
											'c-gold',
											styles.additionalLink,
										)}
										to={getInternalLinkPath(
											menu.additionalLinkTarget.link,
										)}
										onClick={toggleSubmenu}>
										<span
											className={cx(
												'label-italic',
												styles.additionalLinkLabel,
											)}>
											{menu.additionalLinkLabel}
										</span>
										<span
											className={cx(
												'label-caps underline-on-hover',
											)}>
											{menu.additionalLinkTitle}
										</span>
									</Link>
								</div>
							)}
						</div>
					</div>
				</Slide>
			</Modal>
		</>
	);
};
